import { WidgetModule } from "~/services/modules";
import { RecentPostsWidget } from "./widgets/recentPosts";
import { PostsWidget } from "./widgets/posts";

export default class PostsModule extends WidgetModule {

	public constructor() {
		super('posts');
	}
 
	public onSetup(): void | Promise<void> {
		this.registerWidget('posts', new PostsWidget());
		this.registerWidget('recent-posts', new RecentPostsWidget());
	}

	public onReady(): void | Promise<void> {

	}
}